import script from "./sf-assistant-checks-unread-panel.vue?vue&type=script&setup=true&lang=ts"
export * from "./sf-assistant-checks-unread-panel.vue?vue&type=script&setup=true&lang=ts"

import "./sf-assistant-checks-unread-panel.vue?vue&type=style&index=0&id=a03d07d1&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a03d07d1"]])

export default __exports__